import { StorageService } from './../../app/services/storage.service';
import { CancelAsync } from './../../app/models/cancelAsync';

import { Component, HostListener, ViewChild, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {
  NavController,
  Platform,
  ModalController,
  IonContent,
} from '@ionic/angular';

import { ModalMarketingComponent, ModalIframeComponent } from '@app/modals';
import * as moment from 'moment-timezone';
import {
  PageLoaderService,
  AppInitService,
  StatsService,
  StudentService,
  NavigationService,
  NetworkStatusService,
  LessonsService,
} from '@app/services';

import { Student, Serie, StudentPurshasesDetails } from '@app/models';

import { ToasterService, UtilsService } from '@commons/services';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';

@EasyDebugDecorator
@Component({
  selector: 'notation-page',
  templateUrl: 'notation.page.html',
  styleUrls: ['notation.page.scss'],
})
export class NotationPage extends CancelAsync {
  @ViewChild(IonContent, { static: true }) content: IonContent;
  @ViewChild('teacherPicture', { static: true }) teacherPicture: any;

  student: Student = null;
  userLifeCycle: any;

  isDesktop = window.innerWidth > 767 ? true : false;

  pageTitle = 'Leçons à noter';
  activeLink = 'conduite';

  blocHeaderTitle = 'Leçons à noter';

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';

  objectKeys = Object.keys;

  isCordova = false;

  // PAYMENTS GIFTS OFFERS
  studentPurshases: StudentPurshasesDetails;
  payments = [];
  gifts = [];
  coupons = [];
  paymentsGiftsCoupons: any = [];
  offers: any = [];
  fetchOffersFailed = false;
  isPackPermis = false;
  isPackCode = false;
  isHourOnly = false;
  hasHours = false;
  paymentsDone = false;

  pageLoaded = false;

  displayModalOfferNotFound = false;
  modalShown = false;

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;

  lessonId = null;
  lessonToRate: any = {};
  tags = [
    "Pédagogie de l'enseignant",
    'Conseils',
    "Attitude de l'enseignant",
    'Ponctualité',
    'Professionnalisme',
    'Propreté du véhicule',
  ];
  userNotation: any = null;
  userTags: any = [];
  userComments = '';
  isAnonymous = false;
  resetPageFx = false;

  canSubmit = false;
  needComment = false;

  checkedNativePicture = false;
  nbTry = 0;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.isDesktop = window.innerWidth > 767 ? true : false;
  }

  constructor(
    public pageLoaderService: PageLoaderService,
    public navController: NavController,
    public navigationService: NavigationService,
    public appInitService: AppInitService,
    public utils: UtilsService,
    private statsService: StatsService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private studentService: StudentService,
    private modalController: ModalController,
    public renderer: Renderer2,
    public platform: Platform,
    private networkStatusService: NetworkStatusService,
    public lessonsService: LessonsService,
    private toasterService: ToasterService,
    private storageService: StorageService
  ) {
    super({ cancel: false, subscription: null });

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.isCordova = this.platform.is('cordova');

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(
        this.pageLoaderSteps.indexOf('initApp') + 1,
        this.pageLoaderSteps.length
      );
    }
    this.stepChangeSub = this.appInitService.onStepChange().subscribe(state => {
      if (state?.init && state?.stepDone) {
        this.pageLoaderService.setSteps(
          state.init + 1,
          this.pageLoaderSteps.length
        );
      }
      if (state?.initDone) {
        this.initPage();
      }
    });
  }

  ionViewWillLeave() {
    // this.cancel = true;
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (!!this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
  }

  async initPage() {
    this.student = this.studentService.student;
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student);
    this.getPayments();

    if (!this.networkStatusService?.isOffline()) {
      await this.lessonsToRate();
    } else {
      this.openLink('disconnected');
    }

    // PAGE LOAD EVENT
    if (
      !!this.navigationService.timestamp &&
      !!this.navigationService.lastLink
    ) {
      const statObj = {
        page: this.navigationService.lastLink,
        loadTime: Date.now() - this.navigationService.timestamp,
        withInit: this.hasMadeInit,
      };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
    }
  }

  getPayments() {
    this.studentPurshases = this.studentService.getStudentPurshases();

    const resGetOffers = this.studentPurshases.offers;
    if (
      !!resGetOffers &&
      !!resGetOffers.errorCode &&
      resGetOffers.errorCode === 'E301'
    ) {
      this.fetchOffersFailed = true;
    } else {
      this.offers = resGetOffers;
    }
    this.gifts = this.studentPurshases.gifts;
    this.studentPurshases.linkOfferTopayment();
    this.studentPurshases.removeCouponsIfPresentInPayments();
    this.payments = this.studentPurshases.payments;
    this.coupons = this.studentPurshases.coupons;

    this.hasHours = this.studentPurshases.hasHours();
    this.isHourOnly = this.studentPurshases.isHourOnly();
    this.isPackCode = this.studentPurshases.isPackCode();
    this.isPackPermis = this.studentPurshases.isPackPermis();

    const tmp = this.gifts.concat(this.coupons);
    this.paymentsGiftsCoupons = tmp.concat(this.payments);

    this.paymentsDone = true;
    this.pageLoaderService.setSteps(
      this.pageLoaderSteps.indexOf('initPage') + 1,
      this.pageLoaderSteps.length
    );
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 300);
  }

  dateToFormatFr(input?: any) {
    // console.log('-------------------');
    // console.log('dateToFormatFr input', input, typeof input);
    let output = this.dateToMoment(); // today by default
    if (!!input) {
      output = this.dateToMoment(input);
      if (typeof input === 'string') {
        output = this.dateToMoment(input);
        // if (!input.includes('+')) {
        //   console.log('input string', input);
        // }
        if (input.includes('/')) {
          console.error('input string', input);
        }
        // console.log('output', output);
        // console.log('-------------------');
      } else if (typeof input === 'number') {
        // timestamp
        output = this.dateToMoment(input);
        // console.log('input timestamp', input);
        // console.log('output', output);
        // console.log('-------------------');
      } else if (typeof input === 'object') {
        if (
          !moment.isMoment(input) &&
          !!input.year &&
          !!input.month &&
          !!input.day
        ) {
          // custom object
          const year = input.year;
          const month =
            Number(input.month) < 10
              ? '0' + Number(input.month)
              : Number(input.month);
          const day = input.day < 10 ? '0' + input.day : input.day;
          const str = year + '-' + month + '-' + day + ' 00:00:00';
          output = this.dateToMoment(str);
          // console.log('input custom object', input, str);
          // console.log('output', output);
          // console.log('-------------------');
        } else {
          // date object
          output = this.dateToMoment(input);
          // console.log('input date', input, input.isValid());
          // console.log('output', output);
        }
      }
    }
    if (!output.isValid()) {
      console.log('-------------------');
      console.error('dateToFormatFr input', input, typeof input);
      console.error(
        'dateToFormatFr output',
        output,
        output.toString(),
        output.isValid()
      );
      console.error('-------------------');
    }
    // console.log('dateToFormatFr output', output, output.toString(), output.isValid());
    // console.log('-------------------');
    return output;
  }

  dateToMoment(input?: any) {
    const zone = 'Europe/Paris';
    moment.tz.setDefault(zone);
    moment.locale('fr');
    if (!!input) {
      return moment(input).tz(zone);
    }
    return moment().tz(zone);
  }

  async lessonsToRate() {
    const unratedLessons: any = this.lessonsService.newUnratedLessons;
    if (unratedLessons.length > 0) {
      this.blocHeaderTitle = 'Leçons à noter : ' + unratedLessons.length;
      // 0 to N (recent to old)
      const sorted = unratedLessons.sort((a: any, b: any) => {
        // DATE TO CHANGE
        const aDate = this.dateToFormatFr(a.ends_at).valueOf();
        // DATE TO CHANGE
        const bDate = this.dateToFormatFr(b.ends_at).valueOf();
        return aDate - bDate;
      });
      // console.log('sorted unratedLessons', sorted);
      const lastLessontoRate = sorted[sorted.length - 1];
      // console.log(lastLessontoRate);
      if (!!lastLessontoRate) {
        this.lessonId = lastLessontoRate.id;
        this.lessonToRate.teacherName =
          !!lastLessontoRate &&
          !!lastLessontoRate.teacher &&
          !!lastLessontoRate.teacher.first_name
            ? lastLessontoRate.teacher.first_name
            : null;
        let cleanDate = '';
        if (!!lastLessontoRate && !!lastLessontoRate.starts_at) {
          // DATE TO CHANGE
          const date = this.dateToFormatFr(lastLessontoRate.starts_at);
          cleanDate = date.format('dddd DD MMMM YYYY').toLowerCase();
        }
        this.lessonToRate.date = cleanDate;
        let cleanHoraires = '';
        if (!!lastLessontoRate.starts_at && !!lastLessontoRate.duration) {
          // DATE TO CHANGE
          const starts_at = this.dateToFormatFr(lastLessontoRate.starts_at);
          let cleanHour =
            starts_at.hours() < 10
              ? '0' + starts_at.hours()
              : starts_at.hours();
          let cleanMinutes =
            starts_at.minutes() < 10
              ? '0' + starts_at.minutes()
              : starts_at.minutes();
          const starts_at_str = cleanHour + 'h' + cleanMinutes + ' - ';
          starts_at.hours(starts_at.hours() + lastLessontoRate.duration / 3600); // 3600 = 1 hour
          cleanHour =
            starts_at.hours() < 10
              ? '0' + starts_at.hours()
              : starts_at.hours();
          cleanMinutes =
            starts_at.minutes() < 10
              ? '0' + starts_at.minutes()
              : starts_at.minutes();
          const ends_at_str = cleanHour + 'h' + cleanMinutes;
          cleanHoraires = starts_at_str + ends_at_str;
        }
        this.lessonToRate.horaire = cleanHoraires;
        let locationStr = '';
        locationStr +=
          !!lastLessontoRate &&
          !!lastLessontoRate.departure_point &&
          !!lastLessontoRate.departure_point.name
            ? lastLessontoRate.departure_point.name
            : '';
        const separator = locationStr.length > 0 ? ' - ' : '';
        if (
          !!lastLessontoRate &&
          !!lastLessontoRate.departure_point &&
          !!lastLessontoRate.departure_point.city
        ) {
          locationStr +=
            !!lastLessontoRate &&
            !!lastLessontoRate.departure_point &&
            !!lastLessontoRate.departure_point.city
              ? separator + lastLessontoRate.departure_point.city
              : '';
        }
        this.lessonToRate.location = locationStr;
        this.lessonToRate.img =
          !!lastLessontoRate &&
          !!lastLessontoRate.teacher &&
          !!lastLessontoRate.teacher.picture
            ? lastLessontoRate.teacher.picture
            : null;
        if (!!this.lessonToRate.img) {
          const teacherImg =
            !!this.lessonToRate.img.thumb &&
            this.lessonToRate.img.thumb !== 'missing_avatar.png'
              ? this.lessonToRate.img.thumb
              : null;
          this.applyTeacherPicture(teacherImg);
        }
      } else {
        if (!!this.student && !this.student.isGuest()) {
          const toasterConfig = {
            text: 'Aucune leçon à noter : tu vas être redirigé.',
            bgcolor: 'var(--color-danger)',
            duration: '8000',
          };
          this.toasterService.create(toasterConfig);
          this.openLink('conduite');
        } else {
          this.openLink('login');
        }
      }
    } else {
      if (!!this.student && !this.student.isGuest()) {
        const toasterConfig = {
          text: 'Aucune leçon à noter : tu vas être redirigé.',
          bgcolor: 'var(--color-danger)',
          duration: '8000',
        };
        this.toasterService.create(toasterConfig);
        this.openLink('conduite');
      } else {
        const link = 'notation';
        await this.storageService.set('redirectAfterLogIn', link);
        console.log('redirect saved => ', link);
        this.openLink('login');
      }
    }
    this.pageLoaded = true;
  }

  applyTeacherPicture(teacherImg: any) {
    if (
      !!this.teacherPicture &&
      !!this.teacherPicture.nativeElement &&
      !!teacherImg
    ) {
      this.renderer.setStyle(
        this.teacherPicture.nativeElement,
        'background-image',
        'url(' + teacherImg + ')'
      );
    } else {
      if (this.nbTry < 3) {
        setTimeout(() => {
          this.nbTry++;
          this.applyTeacherPicture(teacherImg);
        }, 0);
      } else {
        console.warn('teacherPicture.nativeElement not ready of not found!');
      }
    }
  }

  setUserNotation(note: any) {
    this.userNotation = note;
    if (this.userNotation > 3) {
      this.canSubmit = true;
      this.needComment = false;
    } else {
      if (!!this.userNotation) {
        if (!!this.userComments && this.userComments.length >= 10) {
          this.canSubmit = true;
          this.needComment = false;
        } else {
          this.canSubmit = false;
          this.needComment = true;
        }
      }
    }
  }

  checkUserComment() {
    console.log(this.userComments, this.userComments.length);
    if (!!this.userComments) {
      if (this.userComments.length >= 10) {
        this.needComment = false;
        this.canSubmit = true;
      } else {
        this.needComment = true;
        if (!!this.userNotation && this.userNotation < 4) {
          this.canSubmit = false;
        }
      }
    }
  }

  addUserTag(tag: string) {
    if (!this.userTags.includes(tag)) {
      this.userTags.push(tag);
    } else {
      const ix = this.userTags.indexOf(tag);
      this.userTags.splice(ix, 1);
    }
  }

  triggerActionById(event) {
    if (!!event) {
      if (event.action === 'conduite' && event.value) {
        this.openLink('conduite');
      }
    }
  }

  resetPage() {
    this.resetPageFx = true;
    this.content.scrollToPoint(0, 0, 600);
    this.userNotation = null;
    this.userTags = [];
    this.userComments = null;
    this.isAnonymous = null;
    setTimeout(() => {
      this.resetPageFx = false;
    }, 600);
  }

  async setCheckbox(field: string) {
    if (field === 'anonymous') {
      this.isAnonymous = !this.isAnonymous;
    }
  }

  async sendNotation() {
    const payload: any = {};
    payload.id = this.lessonId;
    payload.rate = this.userNotation;
    payload.comment = this.userComments;
    payload.anonymous = !!this.isAnonymous && this.isAnonymous ? 1 : false;
    payload.tags = this.userTags;
    // console.log(this.lessonId);
    if (!!this.lessonId) {
      // console.log(payload);
      const resPost = await this.lessonsService
        .postUserNotation(payload)
        .toPromise();
      // console.log('resPost', resPost);
      let toasterConfig = null;
      if (!!resPost.rating_id) {
        toasterConfig = {
          text: 'Ta leçon a bien été notée',
          bgcolor: 'var(--color-success)',
          duration: '8000',
        };
        // need to remove lesson from array
        const indexOfLesson = this.lessonsService.newUnratedLessons.findIndex(
          elt => elt.id === this.lessonId
        );
        // console.log(indexOfLesson);
        if (indexOfLesson !== -1) {
          this.lessonsService.newUnratedLessons.splice(indexOfLesson, 1);
        }
        const unratedLessons: any = this.lessonsService.newUnratedLessons;
        // console.log('lessons to rate', unratedLessons);
        if (unratedLessons.length > 0) {
          this.resetPage();
          await this.lessonsToRate();
        } else {
          this.openLink('conduite');
        }
      } else if (!!resPost.status && resPost.status === 403) {
        toasterConfig = {
          text: 'Cette leçon a déjà été notée',
          bgcolor: 'var(--color-danger)',
          duration: '8000',
        };
        setTimeout(() => {
          this.openLink('conduite');
        }, 3000);
      } else if (!!resPost.status && resPost.status === 404) {
        toasterConfig = {
          text: "Cette leçon n'existe pas !",
          bgcolor: 'var(--color-danger)',
          duration: '8000',
        };
        setTimeout(() => {
          this.openLink('conduite');
        }, 3000);
      } else {
        const msg =
          !!resPost.error && !!resPost.error.msg
            ? resPost.error.msg
            : 'Une erreur s’est produite. Merci de réessayer plus tard';
        toasterConfig = {
          text: msg,
          bgcolor: 'var(--color-danger)',
          duration: '8000',
        };
        setTimeout(() => {
          this.openLink('conduite');
        }, 300);
      }
      if (!!toasterConfig) {
        this.toasterService.create(toasterConfig);
      }
    }
  }

  addNewStyle(newStyle) {
    let styleElement = document.getElementById('styles_js');
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.setAttribute('type', 'text/css');
      styleElement.id = 'styles_js';
      document.getElementsByTagName('head')[0].appendChild(styleElement);
    }
    styleElement.appendChild(document.createTextNode(newStyle));
  }

  async openModalPack(
    bannerInfo?: any,
    type?: string,
    noClose = false,
    customClass = ''
  ) {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    if (!!bannerInfo) {
      props = {
        type: type,
        bannerInfo: {
          item_id: bannerInfo.itemId,
          item_promo_type: bannerInfo.itemPromoType,
          item_location_id: bannerInfo.itemLocationId,
          item_location_format: bannerInfo.itemLocationFormat,
          item_promo_content: bannerInfo.itemPromoContent,
        },
      };
    } else {
      props = {
        type: type,
        bannerInfo: null,
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        backdropDismiss: false,
        cssClass: customClass,
        componentProps: props,
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props,
      });
    }
    return await modal.present();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          type: type,
          url: url,
        },
      });
    }
    return await modal.present();
  }

  closeModals() {
    const modals = document.getElementsByTagName('ion-modal');
    while (modals.length > 0) {
      modals[0].parentNode.removeChild(modals[0]);
    }
  }

  async openLink(link, options = {}) {
    const callbackUrl = await this.navigationService.open(link, options);
    if (!!callbackUrl && callbackUrl !== '') {
      this.openModalIframe(callbackUrl);
    }
  }
}
